export default {

  // form and basics
  login: 'Login',
  add: 'Add',
  save: 'Save',
  done: 'Done',
  edit: 'Edit',
  delete: 'Delete',
  cancel: 'Cancel',
  back: 'Back',
  name: 'Name',
  username: 'Username',
  email: 'Email',
  phone: 'Phone',
  password: 'Password',
  oldPassword: 'Old password',
  newPassword: 'New password',
  accountStatus: 'Account status',
  search: 'Search',
  choose: 'Choose...',
  active: 'Active',
  disactive: 'Disactive',
  allRightsRecieved: 'All Rights Recieved',

  // success messages
  savedMessage: 'Saved successfully',

  // error messages
  errorMessage: 'Error',

  // required messages
  nameRequired: 'Name is required',
  usernameRequired: 'Username is required',
  emailRequired: 'Email is required',
  emailValidRequired: 'Email is not valid',
  phoneRequired: 'Phone is required',
  phoneLengthRequired: 'Phone is 11 number',
  passwordRequired: 'Password is required',
  passwordLengthRequired: "Password more than 8 character",
  accountStatusRequired: 'Account status is required',
  userOrPasswordWrong: 'Wrong username or password',

  // side nav
  homepage: 'Homepage',
  settings: 'Settings',
  
  // products
  products: 'Products',

  // articles
  articles: 'Articles',

  // Top navbar
  nav_home: 'Home',
  nav_about_takhaty: 'About Takhaty',
  nav_about_company: 'About the company',
  nav_founder: 'Founder',
  nav_experts: 'Takhaty experts',
  nav_consultations: 'Consultations',
  nav_blog: 'Blog',
  nav_clubs: 'Clubs',
  nav_check_yourself: 'Know yourself',
  nav_study_practice: 'Study & practice',
  nav_creative: 'Creative works',
  nav_publications: 'Publications',
  nav_cme: 'Continuing medical education',
  nav_contact: 'Contact us',
  nav_lang_aria: 'Choose language',
  nav_available_on: 'Available on',
  theme_light: 'Light',
  theme_dark: 'Dark',
  theme_switch_aria_dark: 'Switch to light mode',
  theme_switch_aria_light: 'Switch to dark mode',
  theme_switch_title_dark: 'Dark mode is on — tap for light mode',
  theme_switch_title_light: 'Light mode — tap for dark mode',

  // Landing page
  landing_hero_line1: 'The Arabic network for overcoming stress and improving mood',
  landing_hero_line2: 'Our motto: "In choosing change—there is life and care"',
  landing_hero_line3: 'Passion · Motivation · Achievement · Excellence',
  landing_platform_title: 'Psychological rehabilitation platform',
  landing_platform_lead: 'Work through your challenges and build yourself—in your depths lies strength ready to overcome stress and life’s difficulties.',
  landing_what_we_offer: 'What do we offer?',
  landing_box_psych_support: 'Psychological support platform',
  landing_box_clubs: 'Clubs',
  landing_box_trauma: 'Ease your trauma',
  landing_box_check_self: 'Know yourself',
  landing_box_webinars: 'Webinars',
  landing_box_consultations: 'Consultations',
  landing_download_app: 'Download the app now',
  landing_sessions_title: 'Instant and scheduled consultations',
  landing_sessions_p1: 'Takhaty welcomes all consultations related to psychological and behavioural disorders, marital issues, addiction, and challenges affecting children and adolescents.',
  landing_sessions_p2: 'Takhaty lets you book sessions instantly or schedule ahead.',
  landing_sessions_p3: 'Audio sessions or video calls.',
  landing_sessions_p4: 'Individual and couples sessions.',
  landing_patients_title: 'Featured conditions and topics',
  landing_patients_info: 'Explore problems and conditions and identify what you are going through.',
  landing_patients_more: 'More conditions and topics',
  landing_club_title: 'Takhaty club',
  landing_club_body: 'A club covering different topics where members connect based on interest—through remote psychological meetings that help everyone manage stress, improve mood, and grow using sound therapeutic practice.\n\nTakhaty club relies on well-organised events.\n\nGroup discussions on psychological topics.\n\nWith leading mental health experts and strong clinical takeaways to help everyone overcome stress, psychological difficulties, and life challenges.',
  landing_club_read_more: 'Read more about Takhaty clubs',
  landing_exams_title: 'Know yourself',
  landing_exams_lead_bold: 'Online psychological tests for adults, adolescents, and children',
  landing_exams_quote: '"Knowing what you struggle with is the first step toward healing—test yourself, shape yourself, search your pain; you are the only one who can truly see yourself and choose whether to stay in suffering or move beyond it." — Dr. Hany Fekry Abo Hashem',
  landing_exams_btn_adults: 'Psychological tests for adults',
  landing_exams_btn_teens: 'Tests for adolescents and children',
  landing_blog_title: 'Takhaty blog',
  landing_blog_all: 'All articles',

  // Know yourself (/checkYourSelf)
  check_self_steps_title: 'How the assessment works',
  check_self_step_1: '1. Choose the assessment you want to take.',
  check_self_step_2: '2. Answer the questions.',
  check_self_step_3: '3. Get your result to understand your score level.',
  check_self_features_title: 'Takhaty assessments',
  check_self_feature_1:
    'Practical and therapeutic recommendations to help you move past what you are facing.',
  check_self_feature_2: 'Awareness and education to help you move past what you are facing.',
  check_self_feature_3:
    'You can share your report with Takhaty experts for insight into possible causes of your condition.',
  check_self_exams_intro:
    'Takhaty offers tests and questions that give you a quick, useful picture of your situation and how intense your symptoms may be.',
  check_self_questions_label: 'questions',
  check_self_minutes_label: 'min',
  check_self_app_lead:
    'You can take assessments regularly and track your progress in the Takhaty app.',

  experts_section_h2: 'Takhaty specialists and experts',
  experts_section_bold: 'Licensed mental health professionals with strong experience.',
  experts_section_p: 'Takhaty experts protect participants’ privacy and welcome consultations on psychological and behavioural issues, marital problems, addiction, and child & adolescent challenges.',
  experts_loading_label: 'Loading',
  experts_loading_text: 'Loading experts…',
  experts_grid_empty: 'No experts on this page',

  experts_degree_prefix: 'Holds',
  experts_degree_from: 'from',

  articles_empty: 'No articles found',
  articles_read_more: 'Read more',
  articles_load_more_conditions: 'More conditions and topics',

  articles_page_intro:
    'Articles across specialties and a wide range of conditions—for all ages and groups.',
  articles_page_featured: 'Featured articles',
  articles_filter_type_label: 'Types',
  articles_filter_interests_label: 'Topics',
  articles_interest_required: 'Please choose a topic.',
  articles_subscribe_title: 'Read more articles faster with the Takhaty app.',
  articles_app_unavailable: 'The app is not available yet, but it will be soon.',
  articles_contact_us: 'Contact us',
  articles_card_alt_prefix: 'Article:',

  article_show_more: 'More',
  article_show_less: 'Less',
  article_copy_link_title: 'Copy link',
  article_copy_success_title: 'Copied',
  article_copy_success_body: 'Link copied to the clipboard.',
  article_copy_error_title: 'Error',
  article_copy_error_body: 'Could not copy the link.',

  // About Us (/aboutUs)
  about_intro_title: 'About Takhaty',
  about_intro_subtitle: 'Psychological rehabilitation platform',
  about_founder_label: 'Site founder',
  about_founder_name: 'Dr. Hany Fekry Abo Hashem',
  about_founder_role: 'Founder & CEO',
  about_founder_bio:
    'Consultant in psychotherapy and addiction, internationally certified training consultant, executive director and founder of Takhaty (www.takhaty.com)—the Arabic network for overcoming stress and improving mood.',
  about_message_title: 'Takhaty’s message',
  about_message_p1:
    'Takhaty is home to the Arabic network for overcoming stress and improving mood. Our motto: “In choosing change—there is life and care.”',
  about_message_p2:
    'Moving forward is inner strength that emerges under pressure, trauma, and intense psychological strain—it draws on the resources you already have to get through difficult situations.',
  about_message_p3:
    'It helps shift how you respond in those moments, accept psychological help and support, and recover from stress and related mental health challenges.',
  about_message_quote_intro: 'Here is our message:',
  about_message_quote:
    '“Thinking things through is better for you—and being mindful about how you move past what you face is a strength for you and those around you.”',
  about_goal_label: 'Our aim',
  about_goal_title: 'Takhaty’s goal',
  about_goal_body:
    'Our core aim is to help you build real psychological resilience—to give your mind and body mindful space to face life’s pressures and difficulties, understand them, and work through them before they grow into severe disruptions—so you can keep moving forward on life’s different paths.',

  // About CEO (/abouCEO)
  ceo_page_intro_title: 'Site founder',
  ceo_page_intro_subtitle: 'Meet the founder of Takhaty',
  ceo_section_degrees: 'Academic qualifications',
  ceo_section_memberships: 'Memberships',
  ceo_section_experience: 'Experience',
  ceo_section_publications: 'Publications',
  ceo_section_research: 'Research',
  ceo_section_events: 'Scientific activities & events',
  ceo_degrees_items: [
    '1. Professor of psychotherapy and addiction medicine.',
    '2. Ph.D. in psychotherapy, 2012.',
  ],
  ceo_memberships_items: [
    '1. Member of the Egyptian Society for Psychotherapists (EGYPSYCH), Egypt.',
    '2. Member of the Egyptian Psychological Specialists Association (RANAM), Egypt.',
    '3. Member of the Performance Foundation for Human Development and Training, Egypt.',
    '4. Secretary-General of the General Syndicate for Early Intervention and Inclusion.',
    '5. Member of the Olympic School for sports psychological rehabilitation, Egyptian Karate Federation, Egypt.',
  ],
  ceo_experience_items: [
    '1. Consultant in psychotherapy and addiction, Ministry of Health, Egypt.',
    '2. Internationally certified training consultant (accredited by the Egyptian and Saudi Councils of Ministers).',
    '3. Psychological therapy consultant at Mutmainnah Medical Center, Saudi Arabia.',
    '4. Founder of the Behaviour Unit, Psychiatry & Neurology Department, Al-Ahrar Teaching Hospital, Egypt — 2013.',
    '5. Director of undergraduate training for health students and researchers at Al-Ahrar Hospital, Egypt — 2016–2021.',
    '6. Teaching in mental health departments in higher education — 2016–2021.',
    '7. Psychological development consultant at the National Council for Women, Egypt — 2016.',
    '8. Head of Speech & Language Pathology Department, Al-Ahrar Teaching Hospital, Egypt — 2015.',
    '9. Psychotherapy consultant at Al-Rehab Hospital for mental health and addiction, Egypt — 2014.',
    '10. Trainer for psychological aptitude and traits programmes for military college applicants, Egypt — 2007.',
    '11. Lecturer in personality development programmes, ISO Academy for Quality and Languages, Egypt — 2011.',
    '12. Psychotherapist at Dr. Shaalan Psychiatry Center, Al-Qasr Al-Aini Street, Cairo — 2004.',
    '13. Psychotherapist at Dr. Gamal Abu El-Azayem Psychiatry & Addiction Center, Egypt — 2001.',
    '14. Scientific supervisor of the “Your mental health matters” page, Al-Mujtama Al-Arabi newspaper, Egypt — 2003.',
  ],
  ceo_publications_items: [
    '1. DSM-5 Diagnostic and Statistical Manual of Mental Disorders — edition tailored for addiction and substance-use specialists (digital edition).',
    '2. DSM-5 Diagnostic and Statistical Manual of Mental Disorders — edition tailored for addiction and substance-use specialists (digital edition).',
    '3. DSM-5 Diagnostic and Statistical Manual of Mental Disorders — edition tailored for addiction and substance-use specialists (digital edition).',
  ],
  ceo_research_items: [
    '1. Consultant in psychotherapy and addiction, Ministry of Health, Egypt.',
    '2. Internationally certified training consultant (accredited by the Egyptian and Saudi Councils of Ministers).',
    '3. Psychological therapy consultant at Mutmainnah Medical Center, Saudi Arabia.',
    '4. Founder of the Behaviour Unit, Psychiatry & Neurology Department, Al-Ahrar Teaching Hospital, Egypt — 2013.',
    '5. Director of undergraduate training for health students and researchers at Al-Ahrar Hospital, Egypt — 2016–2021.',
    '6. Teaching in mental health departments in higher education — 2016–2021.',
    '7. Psychological development consultant at the National Council for Women, Egypt — 2016.',
    '8. Head of Speech & Language Pathology Department, Al-Ahrar Teaching Hospital, Egypt — 2015.',
    '9. Psychotherapy consultant at Al-Rehab Hospital for mental health and addiction, Egypt — 2014.',
    '10. Trainer for psychological aptitude and traits programmes for military college applicants, Egypt — 2007.',
    '11. Lecturer in personality development programmes, ISO Academy for Quality and Languages, Egypt — 2011.',
    '12. Psychotherapist at Dr. Shaalan Psychiatry Center, Al-Qasr Al-Aini Street, Cairo — 2004.',
    '13. Psychotherapist at Dr. Gamal Abu El-Azayem Psychiatry & Addiction Center, Egypt — 2001.',
    '14. Scientific supervisor of the “Your mental health matters” page, Al-Mujtama Al-Arabi newspaper, Egypt — 2003.',
    '15. Scientific supervisor of the “Your mental health matters” page, Al-Mujtama Al-Arabi newspaper, Egypt — 2003.',
    '16. Scientific supervisor of the “Your mental health matters” page, Al-Mujtama Al-Arabi newspaper, Egypt — 2003.',
    '17. Scientific supervisor of the “Your mental health matters” page, Al-Mujtama Al-Arabi newspaper, Egypt — 2003.',
  ],
  ceo_events_items: [
    '1. Consultant in psychotherapy and addiction, Ministry of Health, Egypt.',
    '2. Internationally certified training consultant (accredited by the Egyptian and Saudi Councils of Ministers).',
    '3. Psychological therapy consultant at Mutmainnah Medical Center, Saudi Arabia.',
    '4. Founder of the Behaviour Unit, Psychiatry & Neurology Department, Al-Ahrar Teaching Hospital, Egypt — 2013.',
    '5. Director of undergraduate training for health students and researchers at Al-Ahrar Hospital, Egypt — 2016–2021.',
    '6. Teaching in mental health departments in higher education — 2016–2021.',
    '7. Psychological development consultant at the National Council for Women, Egypt — 2016.',
    '8. Head of Speech & Language Pathology Department, Al-Ahrar Teaching Hospital, Egypt — 2015.',
    '9. Psychotherapy consultant at Al-Rehab Hospital for mental health and addiction, Egypt — 2014.',
  ],

  // Experts page (/experts)
  experts_page_hero_kicker: 'Welcome — you’re one of',
  experts_page_hero_title: 'Takhaty’s experts',
  experts_page_hero_lead:
    'Join Takhaty as a physician, psychotherapist, or family counsellor.',
  experts_page_why_title: 'Why practise as a specialist on Takhaty?',
  experts_page_why_lead:
    'Takhaty handles scheduling for your sessions, courses, and webinars end-to-end—and offers a club to discuss cases and connect with people seeking support.',
  experts_page_box_club_title: 'Takhaty club',
  experts_page_box_club_text:
    'Takhaty’s community connects you with clients quickly so you can share ideas and respond to consultations—helping clients discover you as their specialist.',
  experts_page_box_privacy_title: 'Full privacy',
  experts_page_box_privacy_text:
    'No third party sees your conversations with clients—we protect confidentiality on both sides.',
  experts_page_box_support_title: 'Customer care',
  experts_page_box_support_text:
    'Professional customer service with responsive, round-the-clock support for specialists and clients.',
  experts_page_subscribe_heading:
    'Read more articles faster with the Takhaty app.',
  experts_page_app_unavailable:
    'The app isn’t available yet, but it’s coming soon.',

  // Doctor profile (/experts/:id)
  doctor_profile_back: 'Back to experts',
  doctor_profile_loading: 'Loading…',
  doctor_profile_retry: 'Try again',
  doctor_profile_ratings_word: 'ratings',
  doctor_profile_hourly_rate: 'Hourly rate',
  doctor_profile_currency_egp: 'EGP',
  doctor_profile_about: 'About',
  doctor_profile_specializations: 'Specializations',
  doctor_profile_job_title: 'Professional title',
  doctor_profile_academic_degree: 'Academic degree',
  doctor_profile_interests: 'Areas of interest',
  doctor_profile_dob: 'Date of birth',
  doctor_profile_role_fallback: 'Doctor',
  doctor_profile_err_invalid_id: 'Invalid doctor ID',
  doctor_profile_err_not_found: 'Could not load this doctor’s details',
  doctor_profile_err_not_in_list: 'This doctor was not found in the directory',
  doctor_profile_err_network:
    'Could not load doctor data. Check your connection or sign-in.',

  // Consultations list (/consultations)
  consult_page_hero_title: 'Consultations',
  consult_page_hero_lead:
    'Featured questions and answers from Takhaty’s leading specialists.',
  consult_page_blurb_title: 'Takhaty consultations',
  consult_page_blurb_body:
    'Takhaty welcomes consultations on psychological and behavioural issues, marital problems, addiction, and child & adolescent mental health.',
  consult_page_latest_heading: 'Latest consultations',
  consult_page_empty: 'No consultations yet.',
  consult_meta_consultant: 'Consultant',
  consult_meta_published: 'Published',
  consult_meta_views: 'Views',
  consult_meta_country: 'Country',
  consult_meta_age: 'Age',
  consult_card_view_details: 'View details',
  consult_subscribe_heading: 'Send your consultation through the Takhaty app',

  // Consultation detail (/consultation/:id)
  consult_detail_back: '← Back to consultations',
  consult_detail_eyebrow: 'Mental health consultation',
  consult_detail_loading: 'Loading…',
  consult_detail_title_fallback: 'Consultation',
  consult_detail_loading_details: 'Loading details…',
  consult_detail_error_title: 'Could not load this consultation',
  consult_detail_error_hint: 'Check the link or try again later.',
  consult_detail_back_list_btn: 'Back to consultations',
  consult_detail_section_case_meta: 'Case details',
  consult_detail_section_question: 'Question',
  consult_detail_section_reply: 'Reply',
  consult_detail_meta_classification: 'Classification',
  consult_detail_meta_date: 'Date',
  consult_detail_meta_gender: 'Gender',
  consult_detail_no_reply_title: 'No reply yet',
  consult_detail_no_reply_text:
    'Takhaty has not published a reply to this consultation yet. Please check back—this section updates once the specialist’s response is approved.',
  consult_detail_sidebar_title: 'Takhaty consultations',
  consult_detail_sidebar_body:
    'We accept consultations on psychological and behavioural disorders, marital issues, addiction, and child & adolescent wellbeing.',
  consult_detail_all_consultations: 'All consultations',
  consult_detail_strip_title: 'Takhaty consultations',
  consult_detail_age_suffix: 'years',
  consult_detail_gender_male: 'Male',
  consult_detail_gender_female: 'Female',

  // Clubs (/clubs)
  clubs_page_hero_title: 'Takhaty club',
  clubs_page_intro_kicker: 'About',
  clubs_page_intro_title: 'Takhaty club',
  clubs_page_intro_body:
    'Takhaty club brings members together by interest through remote psychological sessions—a practical hub that helps everyone ease stress, lift mood, and grow using sound therapeutic practice. We run organised events that explore psychological topics in groups with leading mental health experts: each session focuses on a specific theme and ends with strong clinical takeaways so people can navigate stress, psychological difficulties, and life challenges—simply and clearly.',
  clubs_followers_label: 'followers',
  clubs_posts_label: 'posts',
  clubs_subscribe_heading:
    'Join Takhaty clubs and share your ideas with specialists',
  clubs_loading: 'Loading clubs…',
  clubs_empty: 'No clubs to show yet.',
  clubs_load_error: 'Could not load clubs. Please try again later.',

  // Creative (/creative)
  creative_hero_title: 'Takhaty creative works',
  creative_hero_subtitle:
    'Drawings and writing from Takhaty users—join us and share your creativity.',
  creative_loading: 'Loading creative works…',
  creative_empty: 'No images to show at the moment.',
  creative_load_more: 'Load more',
  creative_zoom_aria: 'Enlarge image',
  creative_lb_dialog: 'Image preview',
  creative_lb_close: 'Close',
  creative_lb_prev: 'Previous image',
  creative_lb_next: 'Next image',
  creative_lb_of: 'of',
  creative_default_label: 'Creative work',
  creative_subscribe_heading: 'Stay connected with Takhaty app users',

  // Trainings CME (/trainings)
  trainings_hero_title: 'Continuing medical education',
  trainings_hero_subtitle:
    'We keep growing—with experts and users—offering the best courses and trainings so Takhaty specialists stay current in mental health.',
  trainings_section_title: 'Continuing medical education',
  trainings_what_about: 'What is it?',
  trainings_about_body:
    'Takhaty cares not only for visitors but for every expert in the Takhaty family. Our goal is the best outcomes for visitors and cases—only possible through continuous development and up-to-date treatment approaches. Takhaty provides courses and trainings for its experts on the latest methods, preparing them for excellence and ongoing growth.',
  trainings_goals_title: 'Goals of CME training',
  trainings_goal_1: 'Continuous development to ensure the best outcomes.',
  trainings_goal_2: 'Ensuring experts access the latest treatment approaches.',
  trainings_goal_3:
    'Providing the newest courses and trainings—everything experts need in one place.',
  trainings_courses_title: 'CME courses',
  trainings_subscribe_heading:
    'Want to explore all courses, trainings, and subscribe?',

  // Books (/books)
  books_hero_title: 'Takhaty books',
  books_hero_subtitle: 'Books across specialties and topics for all ages and groups.',
  books_latest: 'Latest books',
  books_loading: 'Loading books…',
  books_empty: 'No books available at the moment.',
  books_alt_cover: 'Book cover',
  books_placeholder_title: 'Book',
  books_doctor_label: 'Doctor',
  books_cta_open: 'Open / download book',
  books_viewer_external_link: 'External link',
  books_viewer_close: 'Close',
  books_viewer_pdf_title: 'Book preview',
  books_open_new_tab: 'Open in new tab',
  books_toggle_to_direct: 'Direct from URL',
  books_toggle_to_google: 'View via Google',
  books_viewer_hint:
    'Some hosts block inline PDF playback—try “View via Google” or “Open in new tab”.',
  books_viewer_fallback_text:
    'This link opens an external site rather than a direct PDF in the browser.',
  books_open_link: 'Open link',

  // Contact (/contactUs)
  contact_page_title: 'Contact us',
  contact_hero_lead:
    'Communication is a language only understood by those who know its meaning. Reaching out is a step toward peace between your past, present, and future—to move past challenges and reach your goals, with personal success ahead.',
  contact_intro_heading: 'Contact us',
  contact_intro_body:
    'Tell us if you have a question, want to leave feedback, or need more about Takhaty. We read messages at the email below and will get back to you soon.',
  contact_label_name: 'Name (will not be displayed)',
  contact_label_email: 'Email',
  contact_label_country: 'Country',
  contact_label_subject: 'Subject',
  contact_label_message: 'Your message',
  contact_placeholder_country: 'Search or select a country…',
  contact_country_no_results: 'No matching results',
  contact_country_no_options: 'No countries available',
  contact_err_name_required: 'Name is required',
  contact_err_name_pattern: '2–30 characters, Arabic or English letters only',
  contact_err_email_required: 'Email is required',
  contact_err_email_invalid: 'Email is not valid',
  contact_err_country_required: 'Country is required',
  contact_err_subject_required: 'Subject is required',
  contact_err_message_required: 'Message is required',
  contact_err_message_min: 'Message must be at least 10 characters',
  contact_overlay_sending: 'Sending…',
  contact_submit: 'Send message',
  contact_toast_title: 'Contact us',
  contact_toast_error_title: 'Error',
  contact_turnstile_load_fail:
    'Could not load verification (Cloudflare). Check your connection or disable blockers for challenges.cloudflare.com, then refresh.',
  contact_turnstile_fail:
    'Verification failed. Try refreshing or ensure localhost is allowed in Cloudflare Turnstile.',
  contact_turnstile_complete_first: 'Complete the verification below before sending.',
  contact_countries_load_fail: 'Could not load country list',
  contact_success: 'Your message was sent successfully. We will get back to you soon.',
  contact_send_error: 'Something went wrong while sending. Please try again.',
  contact_webforms_missing:
    'Add VUE_APP_WEB3FORMS_ACCESS_KEY to your .env, stop the server (Ctrl+C), then run npm run serve again—Vue does not pick up .env changes while running.',
  contact_turnstile_aria: 'Verification: I am not a robot',

  // Footer
  footer_tagline: 'Takhaty is home to the Arabic network for overcoming stress and improving mood. Our motto: “In choosing change—there is life and care.”',
  footer_main_links: 'Main links',
  footer_contact_heading: 'Contact',
  footer_email_label: 'Email',
  footer_phone_label: 'Mobile',
  footer_whatsapp_label: 'WhatsApp',
  footer_rights: 'All rights reserved © Takhaty.com',
  footer_blog_link: 'Takhaty blog',
  footer_club_link: 'Takhaty club',
  footer_terms: 'Terms & conditions',
  footer_privacy: 'Privacy policy',

};